/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { MDIStrictHttpResponse } from '../../mdi-strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { KeyValueModel } from '../../models/key-value-model';

export interface MasterDataMaritalStatusTypesGet$Params {
}

export function masterDataMaritalStatusTypesGet(http: HttpClient, rootUrl: string, params?: MasterDataMaritalStatusTypesGet$Params, context?: HttpContext): Observable<MDIStrictHttpResponse<Array<KeyValueModel>>> {
  const rb = new RequestBuilder(rootUrl, masterDataMaritalStatusTypesGet.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as MDIStrictHttpResponse<Array<KeyValueModel>>;
    })
  );
}

masterDataMaritalStatusTypesGet.PATH = '/MasterData/MaritalStatusTypes';
